function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
export var utils = new ( /*#__PURE__*/function () {
  function Utils() {
    var _this = this;
    _classCallCheck(this, Utils);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  _createClass(Utils, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      console.log('TRACKING init'), $(document).on('click', '[data-tracking]', function (e) {
        console.log($(e.target).attr('data-tracking'));
        _this2._sendTracking($(e.target).attr('data-tracking'), {
          page: document.title
        });
      });
      vent.on('TRACK:PCS_END', this.doTrackPCSEnd.bind(this));
      vent.on('TRACK:PCS_BUILD', this.doTrackPCSBuild.bind(this));
      vent.on('TRACK:PCS_PROGRESS', this.doTrackPCSProgress.bind(this));
    }
  }, {
    key: "doTrackPCSEnd",
    value: function doTrackPCSEnd() {
      console.log('doTrackPCSEnd ::');
      this._sendTracking('pcs:end', {
        page: document.title
      });
    }
  }, {
    key: "doTrackPCSBuild",
    value: function doTrackPCSBuild() {
      console.log('doTrackPCSBuild ::');
      this._sendTracking('pcs:generated', {
        page: document.title
      });
    }
  }, {
    key: "doTrackPCSProgress",
    value: function doTrackPCSProgress() {
      var p = 1 * document.querySelector('.pcs-form-timeline').getAttribute('data-percent');
      var doing = null;
      if (p == 25) {
        doing = 25;
      } else if (p == 51) {
        doing = 50;
      } else if (p == 75) {
        doing = 75;
      }
      if (doing) {
        console.log('doTrackPCSProgress :: ', doing);
        this._sendTracking('pcs:progress_' + doing, {
          page: document.title
        });
      }
    }
  }, {
    key: "_sendTracking",
    value: function _sendTracking(event, params) {
      console.log('_sendTracking ::', event, params);
      if (window.pa) {
        pa.sendEvent(event, params);
      }
    }
  }]);
  return Utils;
}())();